export enum ResultType {
  MIN_MAX = 'MIN_MAX',
  PRESENT_ABSENT = 'PRESENT_ABSENT',
  POSITIVE_NEGATIVE = 'POSITIVE_NEGATIVE',
  INCREASED_DECREASED = 'INCREASED_DECREASED',
  REACTIVE_NONREACTIVE = 'REACTIVE_NONREACTIVE',
  OTM = 'OTM',
  NOT_DEFINED = 'NOT_DEFINED' //For not found tests from db
}
